import React from "react";
import { NavbarComp } from '../../component/navbar/navbar';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import { Footer } from "../../component/footer/footer";

function importAll(r) {
    let image = {};
    r.keys()
    .map(i => image[i.replace('./', '')] = r(i));
    return image;
}
const images = importAll(require.context('../../Assets/car_list/', false, /\.(png|jpe?g|svg)$/));

const desc = `Some quick example text to build on the card title and make up the bulk of the card's content.`

const carsCollection = [
        {car : 'agya', desc},
        {car : 'alphard', desc},
        {car : 'avanza', desc},
        {car : 'ayla', desc},
        {car : 'brio', desc},
        {car : 'calya', desc},
        {car : 'elf', desc},
        {car : 'ertiga', desc},
        {car : 'expander', desc},
        {car : 'fortuner', desc},
        {car : 'hiace', desc},
        {car : 'mobilio', desc},
        {car : 'reborn', desc},
        {car : 'rush', desc},
        {car : 'sigra', desc},
        {car : 'terios', desc},
        {car : 'wagonR', desc},
        {car : 'xenia', desc},
    ]

export function CarsMenu() {
    return (
        <>
            <NavbarComp size='50' />
            <h4 className="my-3 text-white text-center">Our Cars</h4>
            <Container fluid='xl' className='d-flex flex-wrap justify-content-center'>
                {carsCollection.map(e => 
                <Card key={e.car} className='m-2 overflow-hidden p-2' style={{width : '20rem'}}>
                    <div className='overflow-auto' style={{ height: '100%'}}>
                    <Card.Img  src={images[`${e.car}.png`]}  />
                    </div>
                    <Card.Title className="text-capitalize">{e.car}</Card.Title>
                    <Card.Text>
                        {e.desc}
                    </Card.Text>
                </Card>
                )}
            </Container>
            <Footer size='30'/>
        </>
    )
}